import { jsx as e } from "react/jsx-runtime";
const t = (o) => /* @__PURE__ */ e("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", "aria-hidden": !0, focusable: !1, ...o, children: /* @__PURE__ */ e("path", { d: "M6.66634 30.6667H1.33301V17.3334H6.66634M6.66634 30.6667H30.666V6.66675L17.3327 2.66675V8.00008M6.66634 30.6667L6.66602 12.0001H19.9993V30.6667M12 21.3335H14.6667M12 25.3335H14.6667M12 17.3335H14.6667M25.333 25.3334V12.0001", stroke: "currentColor", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" }) });
export {
  t as default
};
//# sourceMappingURL=commercial.js.map
